import { render } from "./ObjectivesChart.vue?vue&type=template&id=f4cfa324&scoped=true"
import script from "./ObjectivesChart.vue?vue&type=script&lang=js"
export * from "./ObjectivesChart.vue?vue&type=script&lang=js"

import "./ObjectivesChart.vue?vue&type=style&index=0&id=f4cfa324&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4cfa324"]])

export default __exports__